import {Injectable} from "@angular/core";
import {StorageLocal} from "@app/core/shared/domain/storage/storage.local";
import {WindowService} from "@app/core/shared/domain/window.service";

@Injectable()
export class StorageLocalStorage implements StorageLocal {

    localStorage: Storage | null = null;

    constructor(
        private windowService: WindowService
    ) {
        this.localStorage = windowService.getLocalStorage();
    }

    getItem(key: string): string | null {
        if (!this.localStorage) {
            return null;
        }
        return this.localStorage.getItem(key);
    }

    setItem(key: string, value: string): void {
        this.localStorage?.setItem(key, value);
    }

    removeItem(key: string): void {
        this.localStorage?.removeItem(key);
    }

    clear(): void {
        this.localStorage?.clear();
    }
}
